import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/views/login.vue'
import Registration from '@/views/registration.vue'
import Profile from '@/views/profile.vue'
import Recovery from '@/views/recovery.vue'
import store from '@/store'

Vue.use(VueRouter)

function isAuthorized() {
  return store.getters.isAuthorized
}

const validateAuthorization = (to, from, next) => {
  if (isAuthorized()) {
    next()
  } else {
    next({name: 'home'})
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: {
      name: 'login'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/registration/:code(.*)?',
    name: 'registration',
    component: Registration
  },
  {
    path: '/recovery/:code(.*)?',
    name: 'recovery',
    component: Recovery
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    beforeEnter: validateAuthorization
  },
  {
    path: '*',
    redirect: {
      name: 'login'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && process.env.VUE_APP_USE_AD_AUTH === 'true') {
    next({name: 'login'})
  } else {
    next()
  }
})

export default router
